import { ActionPlanStatus } from "@/modules/ActionPlan/models/ActionPlanStatus.model";
import { ActionGeneralRules } from "@/modules/GeneralRules/models/actions.model";
import { ChangeStateServiceModel } from "@/modules/GeneralRules/models/ChangeStateService.model";
import { FormConfiguration } from "@/modules/GeneralRules/models/FormConfiguration.model";
import { TaskModel } from "@/modules/GeneralRules/models/TaskModel.model";
import { MedicalOrderModel } from "@/modules/MedicalOrder/models/MedicalOrderModel";
import { RECIPIENTS_INIT } from "@/modules/Notification/constants/NotificationConstants";
import { NotificationConfig } from "@/modules/Notification/models/NotificationConfig";
import { Service } from "@/modules/Services/models/Service";
import { ChangeMedicalOrderModel } from "@/modules/GeneralRules/models/ChangeMedicalOrderModel";

export const TYPE_STRING = "string";

export const DEFAULT_ACTION: ActionGeneralRules = {
  type: "",
  actionNotification: {
    recipients: RECIPIENTS_INIT
  } as NotificationConfig,
  daysToApply: 0,
  medicalOrder: {} as MedicalOrderModel,
  task: { recipients: RECIPIENTS_INIT } as TaskModel,
  actionPlan: {} as ActionPlanStatus,
  form: {} as FormConfiguration,
  assignService: {} as Service,
  changeStateService: {} as ChangeStateServiceModel,
  changeMedicalOrder: {} as ChangeMedicalOrderModel
};

export const RELATED_SERVICE = "Servicio relacionado";
